import type { Persistor } from "redux-persist";
import type { AppStore } from "@/store/app/storeTypes";

let appStore: AppStore | null = null;
let appPersistor: Persistor | null = null;

export const setAppStoreInstance = (store: AppStore): void => {
  appStore = store;
};

export const getAppStore = (): AppStore => {
  if (appStore === null) {
    throw new Error("Redux store is not initialized yet");
  }
  return appStore;
};

export const setPersistorInstance = (persistor: Persistor): void => {
  appPersistor = persistor;
};

export const getPersistor = (): Persistor => {
  if (appPersistor === null) {
    throw new Error("Redux persistor is not initialized yet");
  }
  return appPersistor;
};
